
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { List } from 'vant'
import { queryAllIntegral } from '@/apis/portrait'
import { store } from '@/store'
import { formatEnergyDate, formatDate } from '@/utils'
import { parseImgUrl } from '@/utils'

export default defineComponent({
  components: {
    VanList: List
  },
  setup() {
    const list: any = []
    const router: any = useRouter()
    const proxyData = reactive({
      parseImgUrl: parseImgUrl,
      loading: false,
      finished: false,
      nowDate: formatDate('YYYY年MM月DD日'),
      type: 'history',
      totalPage: 0,
      dataMap: {},
      page: 1,
      pageCount: 12,
      user: store.state.user,
      totalPoints: 0,
      todayPoints: 0,
      showNodata: false,
      list: list,
      queryAllIntegral(params: any) {
        queryAllIntegral(params).then(res => {
          const resData: any = res
          const allRes: any = resData?.content ?? []
          proxyData.loading = false
          allRes.forEach(function(item: any) {
            const date: any = proxyData.nowDate
            item.showDate = formatEnergyDate(item.updateTime)[1]
            item.showTime = formatEnergyDate(item.updateTime)[2]
            proxyData.todayPoints = proxyData.todayPoints + Number(item.integral)
            if (proxyData.dataMap[date]) {
              proxyData.dataMap[date].push(item)
            } else {
              proxyData.dataMap[date] = [item]
            }
          })
          if (allRes && allRes.length === 0) {
            proxyData.finished = true
          } else {
            proxyData.page++
          }
          if (proxyData.todayPoints <= 0) {
            proxyData.showNodata = true
          } else {
            proxyData.showNodata = false
          }
        })
      },
      /**
       * 查看今日新增节能
       */
      queryTodayIntegral() {
        let today = formatDate('')
        let params: any = {
          criteria: {
            date: today,
            integral: {
              '$ne': 0
            },
            projectId: proxyData.user.projectId,
            userId: proxyData.user.userId
          },
          'orders': [
            {
              'column': 'updateTime',
              'asc': false
            }
          ],
        }
        proxyData.queryAllIntegral(params)
      },
      onLoad() {
        //  查看今日节能积分
        proxyData.queryTodayIntegral()
      },
      /**
       *  积分说明页面
       */
      goIntegralDesc() {
        router.push({ path: '/integral-desc' })
      },
      /**
       * 查看全部 （历史节能 ）
       */
      showHistory() {
        router.push({
          path: '/energy-detail',
          query: {
            totalPoints: proxyData.totalPoints,
            type: 'history'
          }
        })
      }
    })
    onMounted(() => {
      let route: any = useRoute()
      proxyData.totalPoints = route.query.totalPoints
      proxyData.type = route.query.type
    })
    return {
      ...toRefs(proxyData)
    }
  }
})
